import { ref, onMounted, isRef } from '@vue/composition-api'
export const useFetchData = (api, fromParams = {}, config = { immediate: true }) => {
  const params = fromParams && isRef(fromParams) ? fromParams : ref(fromParams)
  const resData = ref([])
  const error = ref(false)
  const loading = ref(false)

  const fetchData = () => {
    const b = params.value
    const body = {
      ...b
    }
    loading.value = true
    return new Promise((resolve, reject) => {
      api(body)
        .then(({ code, data }) => {
          loading.value = false
          if (code !== 0) {
            error.value = true
            reject(new Error('请求失败'))
            return
          }
          error.value = false
          resData.value = data
          resolve(data)
        })
        .catch((err) => {
          loading.value = false
          error.value = true
          reject(err)
        })
    })
    /* try {
      loading.value = true

      const { data, code } = await api(body)

      if (code !== 0) {
        error.value = true
        return
      }
      error.value = false
      resData.value = data
    } catch (error) {
    } finally {
      loading.value = false
      error.value = true
    } */
  }

  onMounted(() => {
    if (config.immediate) {
      fetchData()
    }
  })

  return {
    loading,
    resData,
    error,
    fetchData
  }
}
